module.exports = __webpack_public_path__ + "static/media/BN.1d197411.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/BN.svg
// module id = 2116
// module chunks = 7